module.exports = __webpack_public_path__ + "img/dy-title-black.9c1bfd4f.png";